// Date helpers — pure, framework-free. Engine layer (framework-free).
/** Whole days between two ISO dates (b - a). Returns 0 on parse failure. */
export function daysBetween(aIso, bIso) {
    const a = parseIso(aIso);
    const b = parseIso(bIso);
    if (!a || !b)
        return 0;
    return Math.round((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
}
/** Today as ISO date string YYYY-MM-DD (pure — caller injects to keep engine deterministic). */
export function todayIso(now = new Date()) {
    return toIsoDate(now);
}
/** Convert a Date to ISO date string YYYY-MM-DD. */
export function toIsoDate(d) {
    const y = d.getUTCFullYear();
    const m = String(d.getUTCMonth() + 1).padStart(2, '0');
    const day = String(d.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
/** Parse an ISO date string into a UTC Date, or null. */
export function parseIso(iso) {
    if (!iso)
        return null;
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m)
        return null;
    const [, y, mo, d] = m;
    return new Date(Date.UTC(Number(y), Number(mo) - 1, Number(d)));
}
/** ISO 8601 timestamp (UTC). Pure given a Date. */
export function toIsoTimestamp(d) {
    return d.toISOString().replace(/\.\d{3}Z$/, 'Z');
}
//# sourceMappingURL=dates.js.map